<template>
  <div>
    <div class="col px-0 pr-lg-3" v-if="memberDetails ? memberDetails.id ? true : false : false">
      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <div class="d-flex justify-content-between align-items-start">
          <h1 class="h2 mb-3">{{split ? 'Split Member Details' : my ? 'My Details' : 'Details'}}</h1>
          <span class="badge badge-info" v-if="memberDetails ? memberDetails.isActive ? true : false : false">Active</span>
          <span class="badge alert-warning" v-else>Inactive</span>
        </div>
        <div class="alert alert-warning" role="alert" v-if="memberDetails ? memberDetails.isActive ? false : true : true">
          Please renew membership.
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 pr-xl-4 form-group">
            <label for="memberNumber">Member Number</label>
            <div class="input-append">
              <input type="text" class="form-control" id="memberNumber" maxlength="10" :value="memberDetails.member_number" readonly>
              <span class="append badge badge-prim">Primary</span>
            </div>
          </div>
          <div class="col-12 col-sm-6 pl-xl-4 form-group">
            <label for="membershipType">Membership Type</label>
            <select class="form-control" id="membershipType" required :value="memberDetails ? memberDetails.type: ''">
              <option disabled></option>
              <option v-for="(membershipType, productsIndex) in $store.state.products.filter(item => item.type === 'Membership' || item.type === 'Addon')" :key="productsIndex">{{membershipType.name}}</option>
            </select>
            <div class="invalid-tooltip">Please include your Membership Type.</div>
          </div>
          <div class="col-12 col-sm-6 pr-xl-4 form-group">
            <label for="firstName">First Name</label>
            <input type="text" class="form-control" id="firstName" maxlength="40" required :value="memberDetails ? memberDetails.first_name: ''">
            <div class="invalid-tooltip">Please include your First Name.</div>
          </div>
          <div class="col-12 col-sm-6 pl-xl-4 form-group">
            <label for="lastName">Last Name</label>
            <input type="text" class="form-control" id="lastName" maxlength="40" required :value="memberDetails ? memberDetails.last_name: ''">
            <div class="invalid-tooltip">Please include your Last Name.</div>
          </div>
          <div class="col-12 col-md-6 no-gutters pr-xl-4">
            <div class="col-12 col-xl-auto form-group">
              <label for="dateOfBirth">Date of Birth</label>
              <input v-model="dateOfBirth" :max="today()" class="form-control" id="dateOfBirth" type="date" placeholder="dd/mm/yyyy" value="1988-01-01" required>
              <div class="invalid-tooltip">Please include your Date of Birth.</div>
            </div>

            <div class="col-12 col-xl pl-xl-3 form-group">
              <label for="gender">Gender</label>
              <select class="form-control" id="gender">
                <option disabled></option>
                <option>Male</option>
                <option>Female</option>
                <option>Unspecified</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-3 pl-xl-4 form-group">
            <label for="riderStatus">Rider Status</label>
            <select class="form-control" id="riderStatus" required>
              <option disabled></option>
              <option v-for="(rStatus, rStatusIndex) in $store.state.riderStatus" :key="rStatusIndex">{{rStatus.name}}</option>
            </select>
            <div class="invalid-tooltip">Please include your Rider Status.</div>
          </div>
          <div class="col-12 col-sm-6 mb-3 pl-xl-4 form-group">
            <label for="membershipStatus">Membership Status</label>
            <select class="form-control" id="membershipStatus" required v-model="memberDetails.membership_status">
              <option disabled></option>
              <option value="Active">Active</option>
              <option value="Archived">Archived</option>
              <option value="Onhold">On Hold</option>
              <option value="Lifetime">Lifetime</option>
              <option value="Suspended">Suspended</option>
            </select>
            <div class="invalid-tooltip">Please include your Membership Status.</div>
          </div>
          <div class="col-12 form-group">
            <label>Eligible for this award</label>
            <div>
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="eligibleAward" id="eligibleMaiden" checked="">
                <label class="custom-control-label font-weight-normal" for="eligibleMaiden">Maiden Rider</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="eligibleAward" id="eligibleNovice">
                <label class="custom-control-label font-weight-normal" for="eligibleNovice">Novice Rider</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="eligibleAward" id="eligibleNone">
                <label class="custom-control-label font-weight-normal" for="eligibleNone">N/A</label>
              </div>
            </div>
          </div>
          <div class="col-12 form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="nonCompetingMembership">
              <label class="custom-control-label" for="nonCompetingMembership">Non-Competing Membership</label>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-primary d-lg-none" @click="handleSubmit">{{split ? 'Publish' : 'Update'}}</button>
            <button class="btn btn-primary ml-2" v-if="memberDetails ? memberDetails.isActive ? false : true : true">Renew</button>
          </div>
        </div>
      </section>
      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <h2 class="mb-4">Contact Details</h2>
        <div class="row">
          <div class="col-12 col-sm-6 pr-xl-4 form-group">
            <label for="email">Email Address</label>
            <input type="email" class="form-control" id="email" maxlength="255" required :value="memberDetails ? memberDetails.email: ''">
            <div class="invalid-tooltip">Please include your Email Address.</div>
          </div>
          <div class="col-12 col-sm-6 pl-xl-4 form-group">
            <label for="phone">Phone Number</label>
            <input type="text" class="form-control" id="phone" maxlength="15" :value="memberDetails ? memberDetails.phone: ''">
          </div>
          <div class="col-12 col-sm-6 pr-xl-4 form-group">
            <label for="mobile">Mobile Number</label>
            <input type="text" class="form-control" id="mobile" maxlength="15" required>
            <div class="invalid-tooltip">Please include your Mobile Number.</div>
          </div>
          <div class="col-12 col-sm-6 pl-xl-4 form-group">
            <label for="address1">Address</label>
            <input type="text" class="form-control" id="address1" maxlength="80" required :value="memberDetails ? memberDetails.attributes.address.street_1: ''">
            <div class="invalid-tooltip">Please include your Address.</div>
          </div>
          <div class="col-12 col-sm-6 pr-xl-4 form-group">
            <label for="suburb">Suburb</label>
            <input type="text" class="form-control" id="suburb" maxlength="40" required :value="memberDetails ? memberDetails.attributes.address.suburb: ''">
            <div class="invalid-tooltip">Please include your Suburb.</div>
          </div>
          <div class="col-12 col-sm-6 mb-4 pl-xl-4 form-group">
            <label for="zone">Zone</label>
            <select class="form-control" id="zone" required>
              <option v-for="(zone, index) in $store.state.listZones" :key="index">{{zone.code}}</option>
            </select>
            <div class="invalid-tooltip">Please include your Zone.</div>
          </div>
          <div class="col-12 col-xl-6 row no-gutters pr-xl-4">
            <div class="col-12 col-md-6 col-xl-auto pr-md-3 pr-xl-0 form-group">
              <label for="postcode">Postcode</label>
              <input type="text" class="form-control" id="postcode" maxlength="4" requred v-model="memberUpdate.attributes.address.postcode" pattern="\d{4}">
              <div class="invalid-tooltip">Please include a four-digit Postcode.</div>
            </div>
            <div class="col-12 col-md-6 col-xl pl-md-3 form-group">
              <label for="state">State</label>
              <select class="form-control" id="state" required v-model="memberUpdate.attributes.address.state">
                <option disabled></option>
                <option value="QLD">Queensland</option>
                <option value="NSW">New South Wales</option>
                <option value="VIC">Victoria</option>
                <option value="ACT">Australian Capital Territory</option>
                <option value="SA">South Australia</option>
                <option value="NT">Northern Territory</option>
                <option value="WA">Western Australia</option>
                <option value="TAS">Tasmania</option>
              </select>
              <div class="invalid-tooltip">Please include your State.</div>
            </div>
          </div>

          <div class="col-12 form-group" v-if="memberUpdate.guardian.consent ? memberUpdate.guardian.consent : isUnder17">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" v-model="memberUpdate.guardian.consent" class="custom-control-input" id="parentalConsent" required>
              <label class="custom-control-label" for="parentalConsent">Parent or guardian gives consent.</label>
            </div>
          </div>
        </div>

        <div v-if="parentConsent || memberUpdate.guardian.consent">
          <h3 class="mb-4">Parent / Guardian Details</h3>
          <div class="row">
            <div class="col-12 col-sm-6 pr-xl-4 form-group">
              <label for="parentFirstName">First Name</label>
              <input type="text" class="form-control" id="parentFirstName" maxlength="40"  v-model="memberUpdate.guardian.first_name" required>
              <div class="invalid-tooltip">Please include the First Name.</div>
            </div>
            <div class="col-12 col-sm-6 pl-xl-4 form-group">
              <label for="parentLastName">Last Name</label>
              <input type="text" class="form-control" id="parentLastName" maxlength="40" required>
              <div class="invalid-tooltip">Please include the Last Name.</div>
            </div>
            <div class="col-12 col-sm-6 pr-xl-4 form-group">
              <label for="parentEmail">Email Address</label>
              <input type="email" class="form-control" id="parentEmail" maxlength="255" required>
              <div class="invalid-tooltip">Please include the Email Address.</div>
            </div>
            <div class="col-12 col-sm-6 pl-xl-4 form-group">
              <label for="mobile">Phone Number</label>
              <input type="text" class="form-control" id="mobile" maxlength="15" required>
              <div class="invalid-tooltip">Please include the Phone Number.</div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 d-flex d-lg-none justify-content-end">
          <button class="btn btn-primary" @click="handleSubmit">{{split ? 'Publish' : 'Update'}}</button>
        </div>
      </section>

      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <h2 class="mb-4">Login Details</h2>
        <div class="row">

          <div class="col-12 col-sm-6 pr-xl-4 form-group">
            <label for="password">Password</label>
            <input type="password" class="form-control" id="password" maxlength="30" v-model="password.password">
            <div class="invalid-tooltip">Please include your password.</div>
          </div>
          <div class="col-12 col-sm-6 pl-xl-4 form-group">
            <label for="confirmPassword">Confirm Password</label>
            <input type="password" class="form-control" id="confirmPassword" maxlength="30" v-model="password.confirmPassword" :required="confirmRequired">
            <div class="invalid-tooltip">Please ensure your passwords match.</div>
          </div>

          <div class="col-12 d-flex d-lg-none justify-content-end">
            <button class="btn btn-primary d-lg-none" @click="handleSubmit">{{split ? 'Publish' : 'Update'}}</button>
          </div>
        </div>
      </section>
    </div>

    <desktop-action-bar>
      <button class="btn btn-block btn-primary mb-2" @click="handleSubmit">{{split ? 'Publish' : 'Update'}}</button>
      <button class="btn btn-block btn-outline-primary" v-if="split">Cancel</button>
      <div v-else>
        <button class="btn btn-block btn-outline-primary" v-if="memberDetails ? memberDetails.isActive ? false : true : true">Renew</button>
        <button class="btn btn-block btn-outline-primary">Deactivate</button>
      </div>
    </desktop-action-bar>
  </div>
</template>

<script>
/* FILE UNUSED */
import HANDLESUBMIT from '@/mixins/formValidation.js'
import FIELDLIST from '@/mixins/getFieldLists.js'
import DesktopActionBar from '@/components/DesktopActionBar'

export default {
  name: 'MembersProfileDetails',
  props: ['memberDetails', 'split', 'my'],
  mixins: [HANDLESUBMIT, FIELDLIST],
  components: {
    DesktopActionBar
  },
  data() {
    return {
      parentConsent: false,
      memberUpdate: this.memberDetails
    }
  },
  watch: {
    memberDetails() {
      this.memberUpdate = this.memberDetails
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-pane {

  section.rounded:first-child {
    border-top-left-radius: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Tabs/MemberDetails.vue